<!--
 * @Description: 作业查询列表公用组件
 * @Author: yangsibo
 * @Date: 2022-06-13 14:53:49
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-13 17:23:25
 * @FilePath: \YunYin_admin\src\components\JobQuery\list.vue
-->

<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
      <div>
        <el-form
          ref="filterForm"
          :inline="true"
          :model="filterForm"
          class="filter-form"
        >
          <el-form-item prop="orderNum">
            <el-input
              v-model="filterForm.orderNum"
              placeholder="订单编号"
              style="width: 180px"
            ></el-input>
          </el-form-item>
          <el-form-item prop="villageId" v-if="orderCategory == 3">
            <el-cascader
              v-model="checkedRegionData"
              :props="regionProps"
              :options="regionData"
              :show-all-levels="false"
              placeholder="所属村"
            ></el-cascader>
          </el-form-item>
          <el-form-item prop="client" v-if="orderCategory == 2">
            <el-input
              v-model="filterForm.client"
              placeholder="委托方"
              style="width: 260px"
            ></el-input>
          </el-form-item>
          <el-form-item prop="orderType">
            <el-select
              v-model="filterForm.orderType"
              placeholder="订单类型"
              style="width: 120px"
            >
              <el-option label="全部" value="0"></el-option>
              <el-option label="全程托管" value="2"></el-option>
              <el-option label="单项服务" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="crop">
            <el-select
              v-model="filterForm.crop"
              placeholder="种植作物"
              style="width: 120px"
            >
              <el-option label="全部" value="0"></el-option>
              <el-option
                v-for="item in cropData"
                :key="item.id"
                :label="item.cropName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="workType">
            <el-select
              v-model="filterForm.workType"
              placeholder="作业类型"
              style="width: 150px"
            >
              <el-option label="全部" value="0"></el-option>
              <el-option
                v-for="item in workTypeData"
                :key="item.id"
                :label="item.workTypeName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="statusFlag">
            <el-select
              v-model="filterForm.statusFlag"
              placeholder="订单状态"
              style="width: 120px"
            >
              <el-option label="全部" value="0"></el-option>
              <el-option
                v-for="item in status"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleFilterPro('filterForm')"
              >查询</el-button
            >
            <el-button
              type="primary"
              plain
              @click="handleResetFilter('filterForm')"
              ><i class="el-icon-refresh-right"></i>清空</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="main">
      <el-table :data="works" style="width: 100%">
        <el-table-column label="序号" width="80" align="center" fixed>
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="orderNum"
          label="订单编号"
          min-width="150"
          align="center"
        >
        </el-table-column>
        <el-table-column
          v-if="orderCategory == 2"
          prop="client"
          label="委托方"
          min-width="150"
          align="center"
        >
        </el-table-column>
        <el-table-column
          v-if="orderCategory == 3"
          prop="villageName"
          label="所属村"
          min-width="150"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="orderTypeName"
          label="订单类型"
          min-width="150"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="cropName"
          label="种植作物"
          min-width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="workTypeName"
          label="作业类型"
          min-width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="orderTime"
          label="作业时间要求"
          min-width="300"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="trusteeshipArea"
          :label="`${orderCategory == 2 ? '托管' : '流转'}面积（亩）`"
          min-width="130"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="trueWorkArea"
          label="作业面积（亩）"
          min-width="130"
          align="center"
        >
        </el-table-column>
        <el-table-column label="作业进度" min-width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.workProgress | formatWorkProgress }}
          </template>
        </el-table-column>
        <el-table-column
          prop="statusName"
          label="状态"
          min-width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              plain
              round
              @click="handleLookDetail(scope.row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,prev, pager, next,jumper"
        :page-size="this.pagination.pageSize"
        :total="pagination.recordTotal"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </el-main>
</template>

<script>
import regionSeatLibs from "utils/regionSeatLibs";
let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c));
export default {
  name: "JobQueryList",
  data() {
    const that = this;
    return {
      filterForm: {},
      cropData: [],
      workTypeData: [],
      status: [
        { id: 5, name: "未派活" },
        { id: 10, name: "已派活" },
        { id: 15, name: "作业中" },
        { id: 20, name: "作业完成" },
      ],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      allFilters: {},
      works: [],
      regionProps: {
        value: "i",
        label: "n",
        children: "c",
        lazy: true,
        lazyLoad(node, resolve) {
          const { level, children, label, value, data } = node;
          // 直辖市的二级（例：海淀区）flag：true代表直辖市
          if (level == 2 && children.length == 0) {
            that.getChildRegion(value, level >= 3, resolve, true);
          }
          if (level == 3 && children.length == 0 && label != "市辖区") {
            let leaf = false;
            if (data.flag) {
              leaf = true;
            } else {
              leaf = false;
            }
            that.getChildRegion(value, leaf, resolve);
          } else if (level >= 4) {
            that.getChildRegion(value, level >= 4, resolve);
          } else {
            resolve();
          }
        },
      },
      regionData,
      checkedRegionData: [],
      masterId: "",
    };
  },
  props: {
    orderCategory: {
      type: Number,
      default: 2,
    },
  },
  filters: {
    formatWorkProgress(value) {
      let result = `${value}%`;
      return result;
    },
  },
  watch: {
    "filterForm.crop"(newValue) {
      if (newValue != 0) {
        this.filterForm.workType = "";
        this.workTypeData = [];
        this.getCropWork2({ cropId2: newValue });
      }
    },
    checkedRegionData(n) {
      this.filterForm.villageId = n[n.length - 1];
    },
  },
  mounted() {
    this.getWorkList();
    this.getAllCropList();
    this.getCropWork2();
  },
  created() {
    this.masterId = this.$route.query.$businessAccountId;
    this.initData();
  },
  methods: {
    /**
     * @description: 数据初始化
     * @Author: yangsibo
     * @Date: 2022-06-13 14:35:19
     * @return {*}
     */
    initData() {
      switch (this.orderCategory) {
        case 2:
          this.filterForm = {
            orderNum: "",
            client: "",
            orderType: "",
            crop: "",
            workType: "",
            statusFlag: "",
            orderCategory: 2, //2: 托管订单，3：流转订单
          };
          break;
        case 3:
          this.filterForm = {
            orderNum: "",
            villageId: "",
            crop: "",
            workType: "",
            statusFlag: "",
            orderCategory: 3, //2: 托管订单，3：流转订单
          };
          break;
        default:
          break;
      }
    },
    /**
     * @descripttion: 获取地区子级数据
     * @Author: juanjuanhui
     * @Date: 2022-04-02 15:45:04
     * @param {*} value 当前节点的value
     * @param {*} leaf 当前节点的leaf
     * @param {*} resolve
     * @param {*} flag 是否是直辖市的标志 非必传
     */
    getChildRegion(value, leaf, resolve, flag) {
      this.$http.common.getChildRegion({ pid: value }).then((res) => {
        let nodes = res.data;
        if (flag) {
          nodes.forEach((item) => {
            item.leaf = leaf;
            item.flag = flag;
          });
        } else {
          nodes.forEach((item) => {
            item.leaf = leaf;
          });
        }
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes);
      });
    },
    /**
     * @descripttion: 获取种植作物下拉框数据
     * @Author: juanjuanhui
     * @Date: 2021-12-19 14:12:00
     */
    getAllCropList() {
      this.$http.common.getAllCropList().then((res) => {
        this.cropData = res.data;
      });
    },
    /**
     * @descripttion: 获取作业类型二级数据
     * @Author: juanjuanhui
     * @Date: 2021-12-19 14:18:11
     */
    getCropWork2(params) {
      this.$http.common.getCropWork2(params).then((res) => {
        this.workTypeData = res.data;
      });
    },
    /**
     * @descripttion: 查询数据
     * @Author: juanjuanhui
     * @Date: 2021-11-30 10:33:18
     */
    handleFilterPro() {
      this.pagination.currentPage = 1;
      this.getWorkList();
    },
    /**
     * @descripttion: 重置筛选条件
     * @Author: juanjuanhui
     * @Date: 2021-11-30 10:34:18
     * @param {String} formName 表单ref名称
     */
    handleResetFilter(formName) {
      this.$refs[formName].resetFields();
      this.pagination.currentPage = 1;
      this.getWorkList();
    },
    /**
     * @descripttion: 获取查询参数
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:06:58
     */
    getAllFilters() {
      this.allFilters = { ...this.filterForm };
      if (this.allFilters.orderType == 0 && this.orderCategory == 2) {
        delete this.allFilters.orderType;
      }
      if (this.allFilters.crop == 0) {
        delete this.allFilters.crop;
      }
      if (this.allFilters.workType == 0) {
        delete this.allFilters.workType;
      }
      if (this.allFilters.statusFlag == 0) {
        delete this.allFilters.statusFlag;
      }
    },
    /**
     * @descripttion: 获取订单列表
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:18:08
     * @param {*}
     */
    getWorkList() {
      this.getAllFilters();
      let { currentPage, pageSize } = this.pagination;
      let params = { currentPage, pageSize, masterId: this.masterId };
      Object.assign(params, params, this.allFilters);
      this.$http.cooperative.getWorkList(params).then((res) => {
        let { recordTotal, content: works } = res.data;
        this.pagination.recordTotal = recordTotal;
        this.works = works;
      });
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:14:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getWorkList();
    },
    /**
     * @descripttion: 查看详情
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:04:18
     * @param {*} params
     */
    handleLookDetail(params) {
      let path =
        this.orderCategory == 2
          ? "/cooperative/trustee/order/job-detail"
          : "/cooperative/transfer/order/job-detail";
      this.$router.push({
        path,
        query: {
          id: params.id,
          order_id: params.orderId,
          orderCategory: this.orderCategory,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
.main {
  .el-table {
    margin-top: 10px;
  }
}
</style>
